// extracted by mini-css-extract-plugin
module.exports = {"root":"Title-module--root--FNs8V"};